import { render } from "./PaginationResult.vue?vue&type=template&id=2b909185"
import script from "./PaginationResult.vue?vue&type=script&lang=js"
export * from "./PaginationResult.vue?vue&type=script&lang=js"

import "./PaginationResult.vue?vue&type=style&index=0&id=2b909185&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__